import React from 'react';
import PropTypes from 'prop-types';
import { useAuthorizationContext } from '../AuthorizationProvider/AuthorizationProvider';
import { Popover, Paper, Button } from '@material-ui/core';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import PersonOutlineOutlinedIcon from '@material-ui/icons/PersonOutlineOutlined';

import styles from './UserProfile.module.css';

const UserProfile = ({ open, handleClose, anchorEl }) => {
  const { user, logoutUser } = useAuthorizationContext();
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <Paper className={styles.container}>
        <div className={styles.display}>
          <div className={styles.iconContainer}>
            <PersonOutlineOutlinedIcon className={styles.personIcon} />
          </div>
          <div className={styles.details}>
            <span className={styles.name}>{user.name}</span>
            <span className={styles.email}>{user.email}</span>
            <Button
              className={styles.logoutButton}
              startIcon={<PowerSettingsNewIcon />}
              onClick={logoutUser}
            >
              Sign Out
            </Button>
          </div>
        </div>
      </Paper>
    </Popover>
  );
};

UserProfile.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  anchorEl: PropTypes.instanceOf(Element),
};

export default UserProfile;
